export default "__VITE_ASSET__D$W7JJLx__"